import React from 'react';
import dateformat from 'dateformat';

import {COMPLETED_KEY} from '@ibibo/myaccount-reducer';

import * as S from './TripsDetails.styles';

import IconSelector from '@ibibo/icon-selector';

const TripDetails = ({data}) => {
  const {travel_start_datetime, travel_end_datetime, rooms, room_night, name, no_of_guest, vendor_fcdt, image, trip_type} = data;

  const isCompleted = (trip_type.toLowerCase() === COMPLETED_KEY);

  const checkin = new Date(travel_start_datetime.replace(/ /g,"T"));
  const checkout = new Date(travel_end_datetime.replace(/ /g,"T"));

  const totalGuests = no_of_guest.childs + no_of_guest.adults;

  return(
    <S.TripInfoDetailsInnerWrap>
      <S.TripDetailOuterWrap>
        <S.TripDetailsWrap>
          <S.CheckText>Check in</S.CheckText>
          <S.DateText>{dateformat(checkin, 'dd mmm \'yy')} <span>{dateformat(checkin, 'dddd')}</span></S.DateText>
          <S.CheckTime>Check In from {dateformat(checkin, 'shortTime')} </S.CheckTime>
        </S.TripDetailsWrap>
        <S.TripDetailsWrap>
          <S.CheckText>Check out</S.CheckText>
          <S.DateText>{dateformat(checkout, 'dd mmm \'yy')} <span>{dateformat(checkout, 'dddd')}</span></S.DateText>
          <S.CheckTime>Check In from {dateformat(checkout, 'shortTime')} </S.CheckTime>
        </S.TripDetailsWrap>
        <S.TripDetailsWrap>
          <S.RoomInfoText completed={isCompleted}>{rooms} Room{rooms > 1 ? 's' : ''}, {room_night} Night{room_night > 1 ? 's' : ''}</S.RoomInfoText>
          <S.TravellerInfoText>{name} {totalGuests > 1 ? `+ ${totalGuests - 1}` : ''}</S.TravellerInfoText>
        </S.TripDetailsWrap>
        <S.TripDetailsWrap>
          <S.RoomImg src={image} alt="hotel pic"></S.RoomImg>
        </S.TripDetailsWrap>
      </S.TripDetailOuterWrap>
      <S.TripAdditionInfoWrap>
        {(!isCompleted && vendor_fcdt && vendor_fcdt !== '' && <S.TripAdditionInfoInnerWrap>
          <S.FreeCancelIcon>
            <IconSelector iconKey='cancelgrey' />
          </S.FreeCancelIcon>
          <S.FreeCancelText>Free cancellation till {dateformat(new Date(vendor_fcdt.replace(/ /g,"T")), 'dd mmm')}</S.FreeCancelText>
        </S.TripAdditionInfoInnerWrap>) || null}
      </S.TripAdditionInfoWrap>
    </S.TripInfoDetailsInnerWrap>
  );
}

export default TripDetails;